export default class {
  constructor(url) {
    this.events = []
    this.request = new XMLHttpRequest()
    this.request.open('GET', url, true)
    this.request.onload = this.onLoad.bind(this)
    this.request.onerror = this.onError.bind(this)
  }

  on(type, fn) {
    this.events[type] = fn
    return this
  }

  trigger(type, data) {
    if (this.events[type]) {
      this.events[type](data)
    }
  }

  send() {
    this.request.send()
  }

  onLoad() {
    if (this.request.status >= 200 && this.request.status < 400) {
      this.trigger('success', this.request.responseText)
      if (this.events['success:json']) {
        this.trigger('success:json', JSON.parse(this.request.responseText))
      }
    } else {
      this.trigger('error', this.request)
    }
  }

  onError() {
    this.trigger('error', this.request)
  }
}
